import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MantenedorCertificadosComponent } from "src/app/components/configuracion-dte/mantenedor-certificados/mantenedor-certificados.component";
import { FacturadorMasivoComponent } from "src/app/components/facturacion/facturador-masivo/facturador-masivo.component";
import { MantenedorClientesComponent } from "../components/administracion/mantenedor-clientes/mantenedor-clientes.component";
import { MantenedorEmisoresComponent } from "../components/administracion/mantenedor-emisores/mantenedor-emisores.component";
import { MantenedorPerfilesComponent } from "../components/administracion/mantenedor-perfiles/mantenedor-perfiles.component";
import { PermissionListComponent } from "../components/administracion/mantenedor-perfiles/permission-list/permission-list.component";
import { MantenedorProductosComponent } from "../components/administracion/mantenedor-productos/mantenedor-productos.component";
import { MantenedorUsuariosComponent } from "../components/administracion/mantenedor-usuarios/mantenedor-usuarios.component";
import { DocumentosRecibidosComponent } from "../components/facturacion/documentos-recibidos/documentos-recibidos.component";
import { FacturadorIndividualComponent } from "../components/facturacion/facturador-individual/facturador-individual.component";
import { MantenedorDteEmitidosComponent } from "../components/facturacion/mantenedor-dte-emitidos/mantenedor-dte-emitidos.component";
import { DashboardWidgetsComponent } from "../components/layout/dashboard-widgets/dashboard-widgets.component";
import { PermissionBlockComponent } from "../components/layout/permission-block/permission-block.component";
import { UserPanelComponent } from "../components/layout/user-panel/user-panel.component";
import { MiCuentaComponent } from "../components/layout/mi-cuenta/mi-cuenta.component";
import { MantenedorProveedorComponent } from "../components/Proveedor/mantenedor-proveedor/mantenedor-proveedor.component";
import { RoleGuard } from "../modules/auth/_services/role.guard";
import { LayoutComponent } from "./_layout/layout.component";
import { MantenedorGuiaDespachoComponent } from "../components/facturacion/mantenedor-guia-despacho/mantenedor-guia-despacho.component";
import { MantenedorDteExportacionComponent } from "../components/facturacion/mantenedor-dte-exportacion/mantenedor-dte-exportacion.component";
import { MantenedorClientesInternacionalesComponent } from "../components/administracion/mantenedor-clientes-internacionales/mantenedor-clientes-internacionales.component";
import { MantenedorCesionarioComponent } from "../components/administracion/mantenedor-cesionario/mantenedor-cesionario.component";
import { MantenedorCesionComponent } from "../components/facturacion/mantenedor-cesion/mantenedor-cesion.component";
import { WizardEmisorComponent } from "../components/administracion/mantenedor-emisores/wizard-emisor/wizard-emisor.component";
import { CompanyPanelComponent } from "../components/layout/company-panel/company-panel.component";
import { MantenedorDteComprasComponent } from "../components/facturacion/mantenedor-dte-compras/mantenedor-dte-compras.component";
import { MantenedorFoliosDefinitivoComponent } from "../components/configuracion-dte/mantenedor-folios-definitivo/mantenedor-folios-definitivo.component";
import { MantenedorAlertasComponent } from "../components/administracion/mantenedor-alertas/mantenedor-alertas.component";
import { MantenedorBheEmitidosComponent } from "../components/facturacion/mantenedor-bhe-emitidos/mantenedor-bhe-emitidos.component";
import { EmisorBoletaHonorariosComponent } from "../components/facturacion/emisor-boleta-honorarios/emisor-boleta-honorarios.component";
import { MantenedorBheRecibidasComponent } from "../components/facturacion/mantenedor-bhe-recibidas/mantenedor-bhe-recibidas.component";
import { PlanPanelComponent } from "../components/layout/plan-panel/plan-panel.component";
import { PlanFacturacionComponent } from "../components/layout/plan-facturacion/plan-facturacion.component";
import { ConsolidadoVentasComponent } from "../components/administracion/consolidados/consolidado-ventas/consolidado-ventas.component";
import { WaitRouteComponent } from "../components/widgets/wait-route/wait-route.component";
import { RegularizacionComponent } from "../components/pago/regularizacion/regularizacion.component";
import { MantenedorBheMasivoComponent } from "../components/facturacion/mantenedor-bhe-masivo/mantenedor-bhe-masivo.component";
import { MantenedorPaykuComponent } from "../components/payku/mantenedor-payku/mantenedor-payku.component";
import { MantenedorServiciosComponent } from "../components/administracion/mantenedor-servicios/mantenedor-servicios.component";
import { MantenedorIntegracionesComponent } from "../components/integraciones/mantenedor-integraciones/mantenedor-integraciones.component";
import { MantenedorPlantillasUsuarioComponent } from "../components/configuracion-dte/mantenedor-plantillas-usuario/mantenedor-plantillas-usuario.component";

const routes: Routes = [
	{
		path: "",
		component: LayoutComponent,
		children: [
			{
				path: "dashboard",
				loadChildren: () => import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
			},
			{
				path: "builder",
				loadChildren: () => import("./builder/builder.module").then((m) => m.BuilderModule),
			},
			{
				path: "inicio",
				component: DashboardWidgetsComponent,
			},
			{
				path: "wait-route",
				component: WaitRouteComponent
			},
			{
				path: "pago/regularizacion",
				component: RegularizacionComponent
			},
			{
				path: "ventas",
				children: [
					{
						path: "boletas-honorarios-emitidas",
						canActivate: [RoleGuard],
						component: MantenedorBheEmitidosComponent,
					},
					{
						path: "boletas-honorarios-masiva",
						canActivate: [RoleGuard],
						component: MantenedorBheMasivoComponent,
					},
					{
						path: "documentos-emitidos",
						canActivate: [RoleGuard],
						component: MantenedorDteEmitidosComponent,
					},
					{
						path: "guias-despacho",
						canActivate: [RoleGuard],
						component: MantenedorGuiaDespachoComponent,
					},
					{
						path: "exportaciones",
						canActivate: [RoleGuard],
						component: MantenedorDteExportacionComponent,
					},
					{
						path: "cesiones",
						canActivate: [RoleGuard],
						component: MantenedorCesionComponent,
					},

					{
						path: "factura-masiva",
						canActivate: [RoleGuard],
						component: FacturadorMasivoComponent,
					},
				],
			},
			{
				path: "compras",
				children: [
					{
						path: "boletas-honorarios-recibidas",
						canActivate: [RoleGuard],
						component: MantenedorBheRecibidasComponent,
					},
					{
						path: "documentos-recibidos",
						canActivate: [RoleGuard],
						component: DocumentosRecibidosComponent,
					},
					{
						path: "facturas-compras",
						canActivate: [RoleGuard],
						component: MantenedorDteComprasComponent,
					},
				],
			},
			{
				path: "mantenedores",
				children: [
					{
						path: "folios",
						canActivate: [RoleGuard],
						component: MantenedorFoliosDefinitivoComponent,
					},
					{
						path: "proveedores",
						canActivate: [RoleGuard],
						component: MantenedorProveedorComponent,
					},
					{
						path: "clientes",
						canActivate: [RoleGuard],
						component: MantenedorClientesComponent,
					},
					{
						path: "cesionarios",
						canActivate: [RoleGuard],
						component: MantenedorCesionarioComponent,
					},
					{
						path: "usuarios",
						canActivate: [RoleGuard],
						component: MantenedorUsuariosComponent,
					},
					{
						path: "productos",
						canActivate: [RoleGuard],
						component: MantenedorProductosComponent,
					},
					{
						path: "servicios",
						canActivate: [RoleGuard],
						component: MantenedorServiciosComponent,
					},
					{
						path: "clientes-internacionales",
						canActivate: [RoleGuard],
						component: MantenedorClientesInternacionalesComponent,
					},
				],
			},
			{
				path: "configuracion",
				children: [
					{
						path: "perfiles",
						canActivate: [RoleGuard],
						component: MantenedorPerfilesComponent,
					},
					{
						path: "perfiles/permisos",
						canActivate: [RoleGuard],
						component: PermissionListComponent,
					},
					{
						path: "alertas",
						canActivate: [RoleGuard],
						component: MantenedorAlertasComponent,
					},
					{
						path: "certificados",
						canActivate: [RoleGuard],
						component: MantenedorCertificadosComponent,
					},
					{
						path: "empresas",
						canActivate: [RoleGuard],
						component: MantenedorEmisoresComponent,
					},
					{
						path: "integraciones",
						canActivate: [RoleGuard],
						component: MantenedorIntegracionesComponent,
					},
					{
						path: "payku",
						canActivate: [RoleGuard],
						component: MantenedorPaykuComponent,
					},
					{
						path: "mis-plantillas",
						canActivate: [RoleGuard],
						component: MantenedorPlantillasUsuarioComponent,
					},
				],
			},
			{
				path: "consolidado/ventas",
				canActivate: [RoleGuard],
				component: ConsolidadoVentasComponent,
			},
			{
				path: "emisor-boletas-honorarios",
				canActivate: [RoleGuard],
				component: EmisorBoletaHonorariosComponent,
			},
			{
				path: "facturador-individual",
				canActivate: [RoleGuard],
				component: FacturadorIndividualComponent,
			},

			
			{
				path: "cuenta",
				canActivate: [RoleGuard],
				component: UserPanelComponent,
			},

			{
				path: "mi-cuenta",
				canActivate: [RoleGuard],
				component: MiCuentaComponent,
			},

			{
				path: "crear-emisor",
				canActivate: [RoleGuard],
				component: WizardEmisorComponent,
			},
			{
				path: "empresa",
				canActivate: [RoleGuard],
				component: CompanyPanelComponent,
			},
			{
				path: "plan",
				redirectTo: "plan-facturacion",
				pathMatch: "full",
			},
			{
				path: "plan-facturacion",
				canActivate: [RoleGuard],
				component: PlanFacturacionComponent,
			},
			{
				path: "bloqueado",
				component: PermissionBlockComponent,
			},
			{
				path: "",
				redirectTo: "/inicio",
				pathMatch: "full",
			},
			{
				path: "**",
				redirectTo: "error/404",
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class PagesRoutingModule {}
